import { render } from "./RealView.vue?vue&type=template&id=4002a3ca&scoped=true"
import script from "./RealView.vue?vue&type=script&lang=js"
export * from "./RealView.vue?vue&type=script&lang=js"

import "./RealView.vue?vue&type=style&index=0&id=4002a3ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4002a3ca"]])

export default __exports__